<!-- eslint-disable vue/multi-word-component-names -->
<!-- ФАЙЛ УПРАВЛЯЕТСЯ ШАБЛОНОМ! НЕ ИЗМЕНЯЙТЕ ЕГО ВРУЧНУЮ! -->
<template>
  <div>
    <RouterView />
    <div
      ref="modalTarget"
      class="modal-target"
    />
  </div>
</template>

<script lang="ts" setup>
  import './styles.scss';

  import { captureException } from '@experience/core-hostapp-share-lib';
  import { initHotReloader, setCssFilesLinksAttribute } from '@experience/vite-plugin-wc-extract-styles';
  import { onErrorCaptured, provide, ref, useShadowRoot } from 'vue';

  import { initApiClient } from '@/shared/api/apiClient';
  import { MF_NAME } from '@/shared/config/env';
  import { getRuntimeConfig } from '@/shared/config/runtime';
  import { trackBranchExperiment } from '@/shared/lib/experiments';

  const sentryDsn = getRuntimeConfig().VITE_RUNTIME_SENTRY_DSN;

  onErrorCaptured((err) => {
    captureException(err, { mf: MF_NAME, dsn: sentryDsn, mfRelease: __APP_VERSION__ });
  });

  // конфигурируем общий API-клиент до рендера дочерних компонентов;
  // аналитика инициализируется лениво при первом useAnalytics()
  initApiClient();

  // отслеживаем эксперименты на ветке
  trackBranchExperiment(import.meta.env.VITE_EXPERIMENT_NAME);

  const shadowRoot = useShadowRoot();
  const modalTarget = ref<HTMLElement | null>(null);

  provide('shadowRoot', shadowRoot);
  provide('modalTarget', modalTarget);

  initHotReloader(import.meta.hot, shadowRoot);

  setCssFilesLinksAttribute(
    shadowRoot,
    import.meta.env.MODE === 'production' ? `/mfs/${MF_NAME}/` : '/',
    'data-external-style-url',
    '%%PROD_STYLESHEET_FILE_LINK%%',
    '',
  );
</script>
